<template>
  <div class="recommend">
    <div class="title t-center bold">我要荐书</div>
    <div class="tip mt-5">
      <span class="bold">温馨提示：</span>组委会对荐书内容进行审核，审核合规后才会发布。
    </div>
    <van-form
      @submit="onSubmit"
      :show-error="false"
      label-width="0"
      ref="form"
      class="form"
    >
      <van-field
        class="mt-6-6 input-style"
        v-model="form.name"
        name="name"
        placeholder="请输入要推荐的书籍名称（必填）"
        :border="false"
        :rules="[{ required: true, message: '请输入要推荐的书籍名称' }]"
      />

      <van-field
        class="mt-6-6 input-style"
        v-model="form.recommend_name"
        name="recommend_name"
        placeholder="请输入荐书人姓名（必填）"
        :border="false"
        :rules="[{ required: true, message: '请输入荐书人姓名' }]"
      />
      <van-field
        class="mt-6-6 input-style"
        v-model="form.recommend_info"
        name="recommend_info"
        rows="6"
        type="textarea"
        placeholder="请输入推荐该书籍的理由（必填）"
        :border="false"
        :rules="[{ required: true, message: '请输入推荐该书籍的理由' }]"
      />
      <van-uploader
        class="mt-6-6"
        v-model="fileList"
        :preview-full-image="false"
        :max-count="1"
        upload-icon="plus"
        :after-read="afterRead"
        image-fit="contain"
        @delete="form.image_path=''"
      />
      <van-button
        block
        type="info"
        native-type="submit"
        :disabled="loading"
        :loading="loading"
        loading-text="确认"
        class="confirm-btn"
      >确定</van-button>

    </van-form>
    <van-popup
      v-model="popupShow"
      :close-on-popstate="true"
      :close-on-click-overlay="false"
      :close-icon="require('@/assets/images/icon-close.png')"
      :closeable="true"
      @closed="popupConfirm"
    >
      <div class="popup-con">提交成功！工作人员将尽快为您审核。审核通过的作品将在自荐图书分类展示并接受投票。</div>
      <van-button
        block
        type="info"
        @click="popupConfirm"
        class="confirm-btn"
      >确定</van-button>

    </van-popup>
  </div>
</template>

<script>
import { imageUpload, setBookInfo } from '@/api'
import { Form, Field, Popup, Button, Uploader } from 'vant'
export default {
  name: 'Recommend',
  components: {
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Uploader.name]: Uploader
  },
  data() {
    return {
      form: {
        name: '',
        recommend_name: '',
        recommend_info: '',
        image_path: ''
      },
      popupShow: false,
      fileList: [],
      loading: false
    }
  },
  methods: {
    // 图片选择后
    afterRead(file) {
      // const uploadfile = file
      file.status = 'uploading'
      file.message = '上传中...'
      var formData = new FormData();//构造一个 FormData，把后台需要发送的参数添加
      formData.append('file', file.file);//接口需要传的参数
      imageUpload(formData).then((res) => {
        this.form.image_path = res.data.image_path
        file.status = ''
        file.message = ''
      }).catch(() => {
        file.status = 'failed'
        file.message = '上传失败'
      })
    },
    onSubmit() {
      console.log(this.form)
      this.loading = true
      setBookInfo(this.form).then(() => {
        this.loading = false
        this.popupShow = true
      }).catch(() => {
        this.loading = false
      })
    },
    popupConfirm() {
      // 重置全部数据
      Object.assign(this.$data, this.$options.data())
    }
  }
}
</script>
<style scoped>
.recommend {
  padding: 6vw 10vw;
}
.recommend .title {
  font-size: 6.4vw;
  color: #e4007f;
}
.recommend .tip {
  color: #333;
  font-size: 3.5vw;
  text-align: justify;
}

.popup-con {
  width: 85%;
  margin: 5vw auto 7vw;
}
</style>
<style>
.van-uploader__upload,
.van-uploader__preview-image {
  background-color: #eee;
  width: 26vw;
  height: 26vw;
}
.van-uploader__upload-icon {
  color: #999;
  font-size: 10vw;
}
.recommend .van-uploader__upload,
.recommend .van-uploader__preview {
  margin: 0;
}
.recommend .van-uploader__wrapper {
  align-items: center;
}
.recommend .van-uploader__wrapper::after {
  content: '上传书籍图片（选填）';
  display: inline-block;
  color: #999;
  width: 6em;
  margin-left: 1em;
}
.van-field__control::-webkit-input-placeholder {
  color: #000;
}
.van-field__control::-moz-input-placeholder {
  color: #000;
}
.van-field__control::-ms-input-placeholder {
  color: #000;
}
</style>